export const pad2 = (v) => (v < 10 ? `0${v}` : `${v}`);
export const pad4 = (v) =>
  v < 10 ? `000${v}` : v < 100 ? `00${v}` : v < 1000 ? `0${v}` : `${v}`;

const shortFormatter = new Intl.DateTimeFormat("default", {
  year: "numeric",
  month: "short",
  day: "numeric",
});

const superShortFormatter = new Intl.DateTimeFormat("default", {
  month: "short",
  day: "numeric",
});

export const shortDate = (date) => {
  const now = new Date();
  const thisYear = now.getFullYear();
  const showYear =
    date.getFullYear() !== thisYear &&
    now.getTime() - date.getTime() > 6 * 30 * 24 * 3600 * 1000;
  return showYear
    ? shortFormatter.format(date)
    : superShortFormatter.format(date);
};

export const startOfDay = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const timeStrToMinutes = (str) => {
  const m = str.match(/(\d+):(\d+)/);
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
};

export const minutesToTimeStr = (mins) => {
  const tailMins = mins % 60;
  const hours = Math.floor((mins - tailMins) / 60);
  return `${pad2(hours)}:${pad2(tailMins)}`;
};

/**
 * Converts a given Date object into a simplified datetime string format.
 *
 * The output string is in the format "YYYY-MM-DD HH:mm", representing
 * the date and time up to minutes, with the "T" character replaced
 * by a space for readability.
 *
 * @param {Date} date - The Date object to be formatted.
 * @returns {string} A formatted datetime string in "YYYY-MM-DD HH:mm" format.
 */
export const toSimpleDateTime = (date) => {
  return date.toISOString().slice(0, 16).replace("T", " ");
};
